import { CanDeactivateFn } from '@angular/router';
import { Observable } from 'rxjs';

/**
 * A component the {@link phoenixUnsavedChangesGuard} can ask before the router navigates
 * away. Implemented by edit/author pages that hold unsaved form state.
 */
export interface HasUnsavedChanges {
  /**
   * Return true to allow leaving, false to stay. May return an `Observable<boolean>` so the
   * component can prompt via the async shared-ui confirmation dialog (CLAUDE.md "window.confirm
   * → app-confirmation-dialog") rather than a blocking `window.confirm`.
   */
  canLeave(): boolean | Observable<boolean>;
}

/**
 * CanDeactivate guard for pages with unsaved form state. Delegates to the component's
 * {@link HasUnsavedChanges.canLeave} (which decides whether to prompt). Mirrors the main
 * portal's unsaved-changes protection; gated on the component implementing the contract so
 * it is a no-op for any page that doesn't.
 */
export const phoenixUnsavedChangesGuard: CanDeactivateFn<Partial<HasUnsavedChanges>> = (component) =>
  typeof component?.canLeave === 'function' ? component.canLeave() ?? true : true;
